var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"clipVideoSkeleton"},[_c('section',{staticClass:"clipVideoSkeleton-main"},[_c('skeleton-box',{staticClass:"clipVideoSkeleton-header"}),_c('skeleton-video',{attrs:{"show-controllers":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }